// client/src/components/forms/Textarea.js
//
// Bare multi-line text input. Same visual treatment as TextInput — same
// border, focus ring, padding. Default rows=4 (compact enough not to
// dominate a form, tall enough to feel like it wants a paragraph).
// Announcement body will bump this to rows=6 at callsite.
//
// Vertical resize disabled — mobile keyboards handle overflow scrolling,
// and free-form resize looks janky next to fixed-height siblings.

export function Textarea({
  value,
  onChange,
  className = '',
  rows = 4,
  ...rest
}) {
  return (
    <textarea
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value)}
      rows={rows}
      className={[
        'block w-full',
        'bg-paper text-ink',
        'border border-rule rounded-md',
        'px-3 py-2',
        'text-base leading-relaxed',
        'placeholder:text-inkSub',
        'focus:outline-none focus:ring-2 focus:ring-accent focus:border-accent',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        'resize-none',
        className,
      ].join(' ')}
      {...rest}
    />
  );
}